import axios from "axios";
import { LOCAL_STORAGE_KEYS, RESULT_CODE } from "../constants/AppConstants";
import { ROUTE_PATHS } from "../constants/Router";
import { hideLoading, showLoading } from "../slice/LoadingSlice";
import { dispatch } from "../store";
import LocalUtils from "../utils/localUtils";

const axiosInstance = (
  isShowLoading = true,
  isShowSuccessMessage = true,
  isShowErrorMessage = true
) => {
  if (isShowLoading) dispatch(showLoading());
  const baseURL = `${process.env.REACT_APP_API_ENPOINT}/${process.env.REACT_APP_API_PREFIX}/v1`;
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        LocalUtils.get(LOCAL_STORAGE_KEYS.ACCESS_TOKEN) || ""
      }`,
    },
  });

  instance.interceptors.response.use(
    (response) => {
      if (isShowLoading) dispatch(hideLoading());
      if (isShowSuccessMessage) {
        if (response.data.success) {
          if (isShowErrorMessage) {
            // toast.success(response.data.msg);
          }
        } else {
          //   toast.error(response.data.msg);
        }
      }

      return response;
    },
    (error) => {
      let message = "";

      if (error.response) {
        let status = error.response.status;
        console.log("status", error.response);
        // when UnAuthorize
        if (
          status === 500 &&
          error.response.data.result_code === RESULT_CODE.UNAUTHORIZE
        ) {
          handleUnAuthorize();
        } else if (error.response.data) {
          if (error.response.data.message) {
            message = error.response.data.message;
          } else if (error.response.data.error_description) {
            message = error.response.data.error_description;
          } else if (error.response.data.title) {
            message = error.response.data.title;
          } else if (typeof error.response.data === "string") {
            message = error.response.data;
          } else {
            message = "오류가 발생했습니다. 잠시 후 다시 시도 해주세요";
          }
        } else {
          message = "오류가 발생했습니다. 잠시 후 다시 시도 해주세요";
        }
      }

      if (message) {
        // toast.error(message);
      }

      if (isShowLoading) dispatch(hideLoading());
      return Promise.reject(error);
    }
  );

  return instance;
};

export const getAsync = (url, params, isShowLoading, isShowSuccessMessage) => {
  return axiosInstance(isShowLoading, isShowSuccessMessage).get(url, {
    params: params,
  });
};

export const postAsync = (
  url,
  json,
  isShowLoading,
  isShowSuccessMessage,
  isShowErrorMessage
) => {
  return axiosInstance(
    isShowLoading,
    isShowSuccessMessage,
    isShowErrorMessage
  ).post(url, json);
};
export const patchAsync = (
  url,
  json,
  isShowLoading,
  isShowSuccessMessage,
  isShowErrorMessage
) => {
  return axiosInstance(
    isShowLoading,
    isShowSuccessMessage,
    isShowErrorMessage
  ).patch(url, json);
};

export const putAsync = (url, json, isShowLoading, isShowSuccessMessage) => {
  return axiosInstance(isShowLoading, isShowSuccessMessage).put(url, json);
};

export const deleteAsync = (url, json, isShowLoading, isShowSuccessMessage) => {
  return axiosInstance(isShowLoading, isShowSuccessMessage).delete(url, {
    data: json,
  });
};

function handleUnAuthorize() {
  LocalUtils.clearAuthenticationInfo();
  window.location.href = ROUTE_PATHS.SignIn;
}
